import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Layout from '../components/common/Layout'
import Home from '../pages/Home'
import Products from '../pages/Products'
import ProductDetail from '../pages/ProductDetail'
import Talents from '../pages/Talents'
import TalentDetail from '../pages/TalentDetail'
import Copyright from '../pages/Copyright'
import CopyrightAnnouncements from '../pages/CopyrightAnnouncements'
import CopyrightAnnouncementDetail from '../pages/CopyrightAnnouncements/[id]'
import CopyrightProducts from '../pages/CopyrightProducts'
import CopyrightProductDetail from '../pages/CopyrightProducts/[id]'
import Activities from '../pages/Activities'
import ActivityDetail from '../pages/ActivityDetail'
import Achievements from '../pages/Achievements'
import AchievementDetail from '../pages/AchievementDetail'
import Partners from '../pages/Partners'
import PartnerDetailPage from '../pages/Partners/[id]'
import Studios from '../pages/Studios'
import StudioDetailPage from '../pages/Studios/studio-detail'
import About from '../pages/About'
import NotFound from '../pages/NotFound'
import International from '../pages/international'
import NewsDetail from '../pages/news/[id]'
import Search from '../pages/Search'

// 占位页面组件
const PlaceholderPage = ({ title }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{title}</h1>
        <p className="text-gray-600">此页面正在开发中，敬请期待...</p>
      </div>
    </div>
  );
};



const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: 'products',
        element: <Products />
      },
      {
        path: 'products/:id',
        element: <ProductDetail />
      },
      {
        path: 'talents',
        element: <Talents />
      },
      {
        path: 'talents/:id',
        element: <TalentDetail />
      },
      {
        path: 'copyright',
        element: <Copyright />
      },
      {
        path: 'copyright/announcements',
        element: <CopyrightAnnouncements />
      },
      {
        path: 'copyright/announcements/:id',
        element: <CopyrightAnnouncementDetail />
      },
      {
        path: 'copyright/products',
        element: <CopyrightProducts />
      },
      {
        path: 'copyright/products/:id',
        element: <CopyrightProductDetail />
      },
      {
        path: 'activities',
        element: <Activities />
      },
      {
        path: 'activities/:id',
        element: <ActivityDetail />
      },
      {
        path: 'achievements',
        element: <Achievements />
      },
      {
        path: 'achievements/:id',
        element: <AchievementDetail />
      },
      {
        path: 'partners',
        element: <Partners />
      },
      {
        path: 'partners/:id',
        element: <PartnerDetailPage />
      },
      {
        path: 'studios',
        element: <Studios />
      },
      {
        path: 'studios/:id',
        element: <StudioDetailPage />
      },
      {
        path: 'about',
        element: <About />
      },
      {
        path: 'search',
        element: <Search />
      },
      {
        path: 'international',
        element: <International />
      },
      {
        path: 'news/:id',
        element: <NewsDetail />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
])

const AppRouter = () => {
  return <RouterProvider router={router} />
}

export default AppRouter 